var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7837_23977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.199997,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7837_23977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 19.0008H9.54625V13.9623C9.54625 13.7063 9.63283 13.4917 9.806 13.3183C9.97933 13.1452 10.194 13.0586 10.45 13.0586H13.95C14.206 13.0586 14.4207 13.1452 14.594 13.3183C14.7672 13.4917 14.8537 13.7063 14.8537 13.9623V19.0008H18.2V10.1546C18.2 10.1034 18.1887 10.057 18.1662 10.0153C18.1439 9.97368 18.1135 9.93676 18.075 9.90459L12.3827 5.62584C12.3314 5.58101 12.2705 5.55859 12.2 5.55859C12.1295 5.55859 12.0686 5.58101 12.0172 5.62584L6.325 9.90459C6.2865 9.93676 6.25608 9.97368 6.23375 10.0153C6.21125 10.057 6.2 10.1034 6.2 10.1546V19.0008ZM4.7 19.0008V10.1546C4.7 9.86843 4.764 9.59734 4.892 9.34134C5.02016 9.08518 5.19716 8.87426 5.423 8.70859L11.1155 4.42009C11.4313 4.17909 11.7923 4.05859 12.1985 4.05859C12.6047 4.05859 12.9667 4.17909 13.2845 4.42009L18.977 8.70859C19.2028 8.87426 19.3798 9.08518 19.508 9.34134C19.636 9.59734 19.7 9.86843 19.7 10.1546V19.0008C19.7 19.4098 19.5522 19.7621 19.2567 20.0576C18.9612 20.3531 18.609 20.5008 18.2 20.5008H14.2577C14.0016 20.5008 13.7869 20.4142 13.6137 20.2408C13.4404 20.0677 13.3537 19.853 13.3537 19.5968V14.5586H11.0462V19.5968C11.0462 19.853 10.9596 20.0677 10.7862 20.2408C10.6131 20.4142 10.3984 20.5008 10.1422 20.5008H6.2C5.791 20.5008 5.43875 20.3531 5.14325 20.0576C4.84775 19.7621 4.7 19.4098 4.7 19.0008Z",
    fill: "#6777A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.035db36b952e2ae432a01fff4a6b2a25.svg";
export { ForwardRef as ReactComponent };